export default "__VITE_ASSET__B8EAlOtA__"